
export const cityMapping = {
  'barcelona': { country: 'Spanje', region: 'Catalonië', city: 'Barcelona' },
  'madrid': { country: 'Spanje', region: 'Madrid', city: 'Madrid' },
  'parijs': { country: 'Frankrijk', region: 'Île-de-France', city: 'Parijs' },
  'paris': { country: 'Frankrijk', region: 'Île-de-France', city: 'Parijs' },
  'rome': { country: 'Italië', region: 'Lazio', city: 'Rome' },
  'roma': { country: 'Italië', region: 'Lazio', city: 'Rome' },
  'milaan': { country: 'Italië', region: 'Lombardije', city: 'Milaan' },
  'venetië': { country: 'Italië', region: 'Veneto', city: 'Venetië' },
  'florence': { country: 'Italië', region: 'Toscane', city: 'Florence' },
  'athene': { country: 'Griekenland', region: 'Attica', city: 'Athene' },
  'athens': { country: 'Griekenland', region: 'Attica', city: 'Athene' },
  'lissabon': { country: 'Portugal', region: 'Lisboa', city: 'Lissabon' },
  'lisbon': { country: 'Portugal', region: 'Lisboa', city: 'Lissabon' },
  'istanbul': { country: 'Turkije', region: 'Istanbul', city: 'Istanbul' },
  'antalya': { country: 'Turkije', region: 'Antalya', city: 'Antalya' },
  'caïro': { country: 'Egypte', region: 'Caïro', city: 'Caïro' },
  'cairo': { country: 'Egypte', region: 'Caïro', city: 'Caïro' },
  // Dubai en UAE steden
  'dubai': { country: 'Verenigde Arabische Emiraten', region: 'Dubai', city: 'Dubai' },
  'abu dhabi': { country: 'Verenigde Arabische Emiraten', region: 'Abu Dhabi', city: 'Abu Dhabi' },
  'sharjah': { country: 'Verenigde Arabische Emiraten', region: 'Sharjah', city: 'Sharjah' },
  // Asian cities
  'bangkok': { country: 'Thailand', region: 'Bangkok', city: 'Bangkok' },
  'ho chi minh stad': { country: 'Vietnam', region: 'Ho Chi Minh', city: 'Ho Chi Minh Stad' },
  'hanoi': { country: 'Vietnam', region: 'Hanoi', city: 'Hanoi' },
  'da nang': { country: 'Vietnam', region: 'Da Nang', city: 'Da Nang' },
  'nha trang': { country: 'Vietnam', region: 'Nha Trang', city: 'Nha Trang' },
  'jakarta': { country: 'Indonesië', region: 'Jakarta', city: 'Jakarta' },
  'yogyakarta': { country: 'Indonesië', region: 'Yogyakarta', city: 'Yogyakarta' },
  'kuala lumpur': { country: 'Maleisië', region: 'Kuala Lumpur', city: 'Kuala Lumpur' },
  'singapore': { country: 'Singapore', region: 'Singapore', city: 'Singapore' },
  'tokyo': { country: 'Japan', region: 'Tokyo', city: 'Tokyo' },
  'kyoto': { country: 'Japan', region: 'Kyoto', city: 'Kyoto' },
  'osaka': { country: 'Japan', region: 'Osaka', city: 'Osaka' },
  'mumbai': { country: 'India', region: 'Maharashtra', city: 'Mumbai' },
  'delhi': { country: 'India', region: 'Delhi', city: 'Delhi' },
  'new delhi': { country: 'India', region: 'Delhi', city: 'New Delhi' },
  'jaipur': { country: 'India', region: 'Rajasthan', city: 'Jaipur' },
  'agra': { country: 'India', region: 'Uttar Pradesh', city: 'Agra' },
  'colombo': { country: 'Sri Lanka', region: 'Western', city: 'Colombo' },
  'kathmandu': { country: 'Nepal', region: 'Bagmati', city: 'Kathmandu' },
  // American cities
  'new york': { country: 'Verenigde Staten', region: 'New York', city: 'New York' },
  'los angeles': { country: 'Verenigde Staten', region: 'California', city: 'Los Angeles' },
  'san francisco': { country: 'Verenigde Staten', region: 'California', city: 'San Francisco' },
  'miami': { country: 'Verenigde Staten', region: 'Florida', city: 'Miami' },
  'las vegas': { country: 'Verenigde Staten', region: 'Nevada', city: 'Las Vegas' },
  'honolulu': { country: 'Verenigde Staten', region: 'Hawaii', city: 'Honolulu' },
  'toronto': { country: 'Canada', region: 'Ontario', city: 'Toronto' },
  'vancouver': { country: 'Canada', region: 'British Columbia', city: 'Vancouver' },
  'montreal': { country: 'Canada', region: 'Quebec', city: 'Montreal' },
  'mexico city': { country: 'Mexico', region: 'Mexico City', city: 'Mexico City' },
  'mexico-stad': { country: 'Mexico', region: 'Mexico City', city: 'Mexico City' },
  'san josé': { country: 'Costa Rica', region: 'San José', city: 'San José' },
  'lima': { country: 'Peru', region: 'Lima', city: 'Lima' },
  'cusco': { country: 'Peru', region: 'Cusco', city: 'Cusco' },
  'buenos aires': { country: 'Argentinië', region: 'Buenos Aires', city: 'Buenos Aires' },
  'santiago': { country: 'Chili', region: 'Santiago', city: 'Santiago' },
  'rio de janeiro': { country: 'Brazilië', region: 'Rio de Janeiro', city: 'Rio de Janeiro' },
  'são paulo': { country: 'Brazilië', region: 'São Paulo', city: 'São Paulo' },
  'havana': { country: 'Cuba', region: 'Havana', city: 'Havana' },
  'havanna': { country: 'Cuba', region: 'Havana', city: 'Havana' },
  'santo domingo': { country: 'Dominicaanse Republiek', region: 'Santo Domingo', city: 'Santo Domingo' },
  'kingston': { country: 'Jamaica', region: 'Kingston', city: 'Kingston' },
  'bridgetown': { country: 'Barbados', region: 'Saint Michael', city: 'Bridgetown' },
  // African cities
  'kaapstad': { country: 'Zuid-Afrika', region: 'Western Cape', city: 'Kaapstad' },
  'cape town': { country: 'Zuid-Afrika', region: 'Western Cape', city: 'Kaapstad' },
  'johannesburg': { country: 'Zuid-Afrika', region: 'Gauteng', city: 'Johannesburg' },
  'durban': { country: 'Zuid-Afrika', region: 'KwaZulu-Natal', city: 'Durban' },
  'nairobi': { country: 'Kenia', region: 'Nairobi', city: 'Nairobi' },
  'dar es salaam': { country: 'Tanzania', region: 'Dar es Salaam', city: 'Dar es Salaam' },
  'marrakech': { country: 'Marokko', region: 'Marrakech', city: 'Marrakech' },
  'casablanca': { country: 'Marokko', region: 'Casablanca', city: 'Casablanca' },
  'tunis': { country: 'Tunesië', region: 'Tunis', city: 'Tunis' },
  // Oceanian cities
  'sydney': { country: 'Australië', region: 'New South Wales', city: 'Sydney' },
  'melbourne': { country: 'Australië', region: 'Victoria', city: 'Melbourne' },
  'brisbane': { country: 'Australië', region: 'Queensland', city: 'Brisbane' },
  'perth': { country: 'Australië', region: 'Western Australia', city: 'Perth' },
  'auckland': { country: 'Nieuw-Zeeland', region: 'Auckland', city: 'Auckland' },
  'wellington': { country: 'Nieuw-Zeeland', region: 'Wellington', city: 'Wellington' },
  'christchurch': { country: 'Nieuw-Zeeland', region: 'Canterbury', city: 'Christchurch' },
  'suva': { country: 'Fiji', region: 'Central', city: 'Suva' }
};
